import React from 'react'
import styled from '@emotion/styled'
import { TrustpilotWidget } from 'components/vendor/TrustpilotWidget'
import { mediaQueriesByDevice, ROUTES } from 'parameters/index'
import { Container } from 'components/layout'
import { withInlineSVG } from 'components/patterns/icons/svg-tools/generator/withInlineSVG'
import { LinkButton } from 'ui/inputs/Button/LinkButton'

export interface Props {
	imgSrc: string
	title: string
	text: string
	buttonText: string
	buttonHref?: string
}

export const TrustpilotAside: React.FC<React.PropsWithChildren<Props>> = ({
	imgSrc,
	title,
	text,
	buttonHref = ROUTES.SEARCH,
	buttonText
}) => {
	const MoneyBagIcon = withInlineSVG(imgSrc)

	return (
		<OutsideContainer>
			<StyledContainer>
				<ImageContainer>
					<MoneyBagIcon />
				</ImageContainer>
				<InnerContainer>
					<h2>{title}</h2>
					<StyledP>{text}</StyledP>
					<BottomWrapper>
						{/* Link Button */}
						<LinkButton href={buttonHref}>{buttonText}</LinkButton>
						<TrustpilotWidget widget="microStar" />
					</BottomWrapper>
				</InnerContainer>
			</StyledContainer>
		</OutsideContainer>
	)
}

const OutsideContainer = styled(Container)`
	max-width: 1280px;
	${mediaQueriesByDevice.mobile} {
		padding: 0;
	}
`

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 64px 120px;
	background: linear-gradient(277.3deg, #f9f2ff 0%, #fcf9ff 100%);
	border-radius: 24px;

	${mediaQueriesByDevice.laptop} {
		padding: 64px 24px;
	}

	${mediaQueriesByDevice.mobile} {
		padding: 48px 16px;
		flex-direction: column;
		text-align: center;
		border-radius: 0;

		h2 {
			margin-top: 16px;
		}
	}
`

const ImageContainer = styled.div`
	width: 243px;
	flex-shrink: 0;

	${mediaQueriesByDevice.mobile} {
		width: 140px;
	}
`

const InnerContainer = styled.div`
	max-width: 700px;
	padding-left: 24px;
	width: 100%;

	${mediaQueriesByDevice.mobile} {
		padding-left: 0;
	}
`

const BottomWrapper = styled.div`
	display: flex;
	align-items: center;

	button {
		width: 270px;
		padding: 0;
	}

	// Unset the trustpilot default width
	> div {
		width: unset !important;
	}

	${mediaQueriesByDevice.mobile} {
		flex-direction: column;
		gap: 1rem;
	}
`

const StyledP = styled.p`
	margin: 24px 0;
`
